import React from "react";
import i18n from "@/i18n";

import bookImg from "@/assets/images/promotion/credentials-carousel/handbok-bolagsstyrning.png";
import { Trans } from "react-i18next";
import { Button } from "@/components/ui/button";
import { ShoppingCart } from "lucide-react";
import history from "@/interfaces/history";

const { t } = i18n;

const CoffeeTableBookAlert = () => {
  return (
    <div className="dialog-sheen flex gap-6 rounded-xl bg-brand-900 p-6 text-white">
      <div className="flex w-full justify-between gap-8">
        <div>
          <img
            className="max-w-[40px] drop-shadow-[0_5px_5px_rgba(255,255,255,0.25)]"
            src={bookImg}
          />
        </div>
        <div className="flex-1">
          <div className="text-lg font-semibold">
            <Trans i18nKey="coffee_table_book_promotion.heading" />
          </div>
          <div>{<Trans i18nKey={t("coffee_table_book_promotion.body")} />}</div>
        </div>
        <div className="flex h-full items-center justify-end gap-2">
          <Button
            variant="outline-contrast"
            onClick={() => {
              history.push("/personal-documents");
            }}
          >
            {t("generic.download_pdf")}
          </Button>
          <Button
            variant="outline-contrast"
            onClick={() => {
              window.open(
                "https://www.invono.se/handbok-bolagsstyrning",
                "_blank",
              );
            }}
          >
            <ShoppingCart size={16} />
            {t("coffee_table_book_promotion.buy_hard_copy")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CoffeeTableBookAlert;
